import { type CSSProperties } from "styled-components";
import { StyledGalleryContent, StyledPhotoCamera, StyledSkeleton } from "./styles";

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  animate?: boolean;
  type: "text" | "button" | "image" | "gallery" | "card";
  width?: CSSProperties["width"];
  height: CSSProperties["height"];
  children?: React.ReactNode;
  backgroud?: CSSProperties["background"];
  borderRadius?: CSSProperties["borderRadius"];
  withBorder?: boolean;
  withIconImage?: boolean;
  opacity?: CSSProperties["opacity"];
}

const Skeleton = ({
  animate,
  type = "text",
  width = "100%",
  height,
  children,
  backgroud,
  borderRadius,
  withBorder = true,
  withIconImage = true,
  opacity = "100%",
  ...props
}: SkeletonProps) => {
  return (
    <StyledSkeleton
      $animate={animate}
      $type={type}
      $width={width}
      $height={height}
      $backgroud={backgroud}
      $borderRadius={borderRadius}
      $opacity={opacity}
      {...props}
    >
      {children}
      {type === "gallery" && (
        <StyledGalleryContent $withBorder={withBorder}>
          <StyledPhotoCamera />
        </StyledGalleryContent>
      )}

      {type === "image" && withIconImage && <StyledPhotoCamera />}
    </StyledSkeleton>
  );
};

export default Skeleton;
